export class FetchError extends Error {
    queryType;
    recordType;
    context;
    constructor(args) {
        super(args.message);
        this.name = "FetchError";
        this.queryType = args.queryType;
        this.recordType = args.recordType;
        this.context = args.context;
    }
}
export class ApiError extends Error {
    status;
    queryType;
    recordType;
    context;
    constructor(args) {
        super(args.message);
        this.name = "ApiError";
        this.status = args.status;
        this.queryType = args.queryType;
        this.recordType = args.recordType;
    }
}
export class NoAuthTokenError extends Error {
    context;
    constructor(args) {
        super("No auth token provided");
        this.name = "NoAuthTokenError";
        this.context = args?.context;
    }
}
//# sourceMappingURL=errors.js.map